<template>
    <div>
        <h1>已经成功付款notify_url</h1>
        <el-button @click="returnBefore">返回之前页面</el-button>
    </div>
</template>
<script>
export default {
    data(){
        return {}
    },
    methods:{
        returnBefore(){
            let url = localStorage.getItem("beforeOfPay");
            window.location.replace(url);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/view/pay/notify_url.vue